import * as React from 'react'
import {Checkbox, Col, DatePicker, Form, Icon, Input, Row} from 'antd';
import {WithTranslation} from 'react-i18next';
import {NewProjectItem} from 'src/stores/projects-store';
import {nameof} from 'src/core/utils/object';
import {GetFieldDecoratorOptions} from 'antd/lib/form/Form';
import EditableTooltip from '../../../components/editable-tooltip/tooltip';
import moment from 'moment-timezone'
import {Moment} from 'moment'
import autobind from 'autobind-decorator';
import LabelIcon from '../../../components/editable-tooltip/label-icon';

let FormItem = Form.Item;
let { RangePicker } = DatePicker;

interface ProjectEditFormBodyProps extends WithTranslation {
    item: NewProjectItem | undefined,
    onSave?: () => Promise<any>;
    getFieldDecorator<T extends Object = {}>(id: keyof T, options?: GetFieldDecoratorOptions): (node: React.ReactNode) => React.ReactNode;
    readOnly?: boolean
}

interface ProjectEditFormBodyState {
    startDate?: Moment
    endDate?: Moment | null
    isSelectingDate?: boolean
}

export class ProjectFormBody extends React.Component<ProjectEditFormBodyProps, ProjectEditFormBodyState> {
    constructor(props: ProjectEditFormBodyProps) {
        super(props);
        this.state = {
        }
    }

    static getDerivedStateFromProps(props: ProjectEditFormBodyProps, state: ProjectEditFormBodyState) {
        if (state.startDate === undefined || !state.startDate.isValid()) {
            state.startDate = (props.item) ? moment.unix(props.item.fromDate) : undefined
        }
        if (state.endDate === undefined || !state.endDate?.isValid()) {
            state.endDate = (props.item && props.item.toDate) ? moment.unix(props.item.toDate) : undefined
        }
    }

    @autobind
    private onOpenCalendar(status: boolean) {
        if (status)
            this.setState({
                isSelectingDate: status
            })
        else
            this.setState({
                isSelectingDate: undefined
            })
    }

    @autobind
    private onSelectStartDate(date: Moment | null) {
        let selectedDate = date ? date.startOf("day").utc() : moment.utc().startOf("day")
        this.setState({
            startDate: selectedDate
        })
    }

    @autobind
    private onSelectEndDate(date: Moment | null) {
        let selectedDate = date ? date.startOf("day").utc() : null
        this.setState({
            endDate: selectedDate
        })
    }

    @autobind
    private disabledEndDate(date: Moment | null) {
        if (!date)
            return false
        return date.utc().startOf("day") <= (this.state.startDate ?? moment().utc())
    }

    @autobind
    private async validateEndDate(rule: any, value: any) {
        if (value != undefined) {
            let endDate = (value as Moment).utc().startOf("day")
            let startDate = this.state.startDate ?? moment.utc().startOf("day")
            if (startDate.unix() > endDate.unix()) {
                throw new Error("End date must be bigger than start date")
            }
        }
    }

    render() {
        const { t } = this.props;
        var item = this.props.item || {} as NewProjectItem;
        return <Form id="modaForm" onSubmit={() => { if (this.props.onSave) { this.props.onSave(); } }}>
            <Row gutter={24}>
                <Col span={24}>
                    <FormItem label={t("Name")}>
                        {this.props.getFieldDecorator(nameof<NewProjectItem>('title'), {
                            initialValue: item.title,
                            rules: [
                                { required: true, message: t('Title required') },
                                { whitespace: true, message: t('Title required') }],
                        })(
                            <Input placeholder={t("Name")} type="text" disabled={this.props.readOnly} maxLength={255}/>
                        )}
                    </FormItem>
            </Col>
            </Row>
          <Row gutter={24}>
            <Col span={12}>
              <FormItem label={t("Code")}>
                {this.props.getFieldDecorator(nameof<NewProjectItem>('code'), {
                  initialValue: item.code,
                  rules: [{ max: 255, message: t('Maximum length is 255 characters') }],
                })(
                  <Input placeholder={t("Code")} type="text" disabled={this.props.readOnly} maxLength={255} />
                )}
              </FormItem>
            </Col>
                <Col span={12}><EditableTooltip name='project-reference' noIcon>
                    <FormItem label={(
                        <LabelIcon>
                            { t("Reference")}
                        </LabelIcon>
                    )}>
                        {this.props.getFieldDecorator(nameof<NewProjectItem>('reference'), {
                            initialValue: item.reference,
                            rules: [{ required: false, message: t('Reference required') }],
                        })(
                            <Input placeholder={t("Optional reference")} type="text" disabled={this.props.readOnly} maxLength={255} />
                        )}
                    </FormItem></EditableTooltip>
                </Col>
            </Row>
            <Row gutter={24}>
                <Col span={16}>
                    <EditableTooltip name='project-is-private' noIcon>
                        <FormItem>
                            {this.props.getFieldDecorator(nameof<NewProjectItem>('isPrivate'), {
                                rules: [], initialValue: item.isPrivate, valuePropName: 'checked'
                            })(
                                <Checkbox disabled={this.props.readOnly}><span>{t("Project is private")}</span><Icon type="info-circle" style={{ fontSize: '12px', color: 'grey', marginRight: 3, marginLeft: 3 }} /> </Checkbox>
                            )}
                            <small style={{ display: 'block', marginLeft: 25, marginTop: -7, lineHeight: 1.5 }}>{t("Private projects are seen only by project members. Public projects in other hand, can be seen and used by anyone.")}</small>
                        </FormItem>
                    </EditableTooltip>
            </Col>
            {/*<Col span={8}>*/}
            {/*  <FormItem>*/}
            {/*    {this.props.getFieldDecorator(nameof<NewProjectItem>('billable'), {*/}
            {/*      rules: [], initialValue: item.billable, valuePropName: 'checked'*/}
            {/*    })(*/}
            {/*      <Checkbox><span>{t("Billable") + "?"}</span></Checkbox>*/}
            {/*    )}*/}

            {/*  </FormItem>*/}
            {/*</Col>*/}
            </Row>
            {
                (item.allowedCii || item.allowedCir) &&
                <Row gutter={24}>
                    {
                        item.allowedCir &&
                        <Col span={12}>
                            <FormItem>
                                {this.props.getFieldDecorator(nameof<NewProjectItem>('rdTaxRelief'), {
                                    rules: [], initialValue: item.rdTaxRelief, valuePropName: 'checked'
                                })(
                                    <Checkbox disabled={this.props.readOnly || !item.allowedCir}><span>{t("R&D Tax relief?")}</span></Checkbox>
                                )}

                            </FormItem>
                        </Col>
                    }
                    {
                        item.allowedCii &&
                        <Col span={12}>
                            <FormItem>
                                {this.props.getFieldDecorator(nameof<NewProjectItem>('tiTaxRelief'), {
                                    rules: [], initialValue: item.tiTaxRelief, valuePropName: 'checked'
                                })(
                                    <Checkbox disabled={this.props.readOnly || !item.allowedCii}><span>{t("TI Tax relief?")}</span></Checkbox>
                                )}

                            </FormItem>
                  </Col>}
              

                </Row>
            }
            <Row gutter={24}>
                <Col span={12}>
                    <FormItem label={(
                        <EditableTooltip
                            name='new-project-dates'
                            visible={this.state.isSelectingDate === undefined ? undefined : !this.state.isSelectingDate}
                        >
                            { t("Start date")}
                        </EditableTooltip>
                    )}>
                        {this.props.getFieldDecorator(nameof<NewProjectItem>('fromDate'), {
                            initialValue: (this.props.item) ? moment.unix(this.props.item.fromDate) : undefined,
                            rules: [{ required: false, message: t('Start date required') }],
                        })(
                            <DatePicker
                                disabled={this.props.readOnly}
                                onOpenChange={this.onOpenCalendar}
                                onChange={this.onSelectStartDate} />
                        )}
                    </FormItem>
                </Col>
                <Col span={12}>
                    <FormItem label={(
                        <EditableTooltip
                            name='new-project-dates'
                            visible={this.state.isSelectingDate === undefined ? undefined : !this.state.isSelectingDate}
                        >
                            { t("End date")}
                        </EditableTooltip>
                    )}>
                        {this.props.getFieldDecorator(nameof<NewProjectItem>('toDate'), {
                            initialValue: (this.props.item && this.props.item.toDate) ? moment.unix(this.props.item.toDate) : undefined,
                            rules: [{ required: false, message: t('End date required') }, { validator: this.validateEndDate }],
                        })(
                            <DatePicker
                                disabled={this.props.readOnly}
                                onOpenChange={this.onOpenCalendar}
                                onChange={this.onSelectEndDate}
                                disabledDate={this.disabledEndDate}
                                value={this.state.endDate} />
                        )}
                    </FormItem>
                </Col>
            </Row>
        </Form>
    }
}